<nav class="breadcrumb">
  <button type="button" class="crumb crumb-link" (click)="navigateHome()">
    Home
  </button>

  <ng-container *ngIf="activeMenu">
    <span class="chevron">
      <svg width="12" height="12" viewBox="0 0 12 12" class="cursor-pointer">
        <use [attr.xlink:href]="svgPath + 'sprite.svg#breadcrumb'"></use>
      </svg>
    </span>

    <span class="crumb-parent">
      <button
        type="button"
        class="crumb"
        [class.crumb-link]="activeSubItem"
        [class.crumb-current]="!activeSubItem"
        [attr.aria-expanded]="isDropdownOpen"
        aria-haspopup="true"
        (click)="toggleDropdown()"
      >
        {{ activeMenu.menu_name }}
      </button>

      <svg
        *ngIf="visibleSubItems.length"
        width="8"
        height="8"
        viewBox="0 0 8 8"
        class="dropdown-caret"
        [class.open]="isDropdownOpen"
        aria-hidden="true"
      >
        <use [attr.xlink:href]="svgPath + 'sprite.svg#breadcrumb-caret'"></use>
      </svg>

      <ul class="breadcrumb-dropdown" *ngIf="isDropdownOpen">
        <li
          *ngFor="let sub of visibleSubItems"
          [class.active]="sub === activeSubItem"
        >
          <button type="button" (click)="navigateToSub(sub)">
            {{ sub.sub_menu_name }}
          </button>
        </li>
      </ul>
    </span>
  </ng-container>

  <ng-container *ngIf="activeSubItem">
    <span class="chevron">
      <svg width="12" height="12" viewBox="0 0 12 12" class="cursor-pointer">
        <use [attr.xlink:href]="svgPath + 'sprite.svg#breadcrumb'"></use>
      </svg>
    </span>
    <span class="crumb crumb-current">{{ activeSubItem.sub_menu_name }}</span>
  </ng-container>
</nav>
